var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('router-view'),_c('v-footer',{staticStyle:{"background-color":"#212944"}},[_c('v-spacer'),_c('small',{staticClass:"white--text"},[_vm._v(" Actualización Noviembre 2024 - v3.2.5 b2 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }